import {EntityManager, Repository} from "aurelia-orm";
import {ItemTypeBase} from "./item-type-base";

export class ItemTypeServiceBase<T extends ItemTypeBase> {

    repository: Repository;

    constructor(entityType: string, private entityManager: EntityManager) {
        this.repository = entityManager.getRepository(entityType);
    }

    list(): Promise<Array<T>> {
        return this.repository.find('list');
    }

    getNew(): T {
        return this.repository.getNewEntity();
    }
    
}